import { useEffect, useRef } from "react";

const SCRIPT_SRC = "https://www.instagram.com/embed.js";

type InstagramWindow = Window & {
  __igEmbedLoaded?: boolean;
  instgrm?: { Embeds?: { process: () => void } };
};

function loadInstagramScript() {
  if (typeof window === "undefined") return;
  const w = window as InstagramWindow;
  if (w.instgrm?.Embeds?.process) {
    w.instgrm.Embeds.process();
    return;
  }
  if (w.__igEmbedLoaded) return;
  w.__igEmbedLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = SCRIPT_SRC;
  document.body.appendChild(s);
}

export const InstagramEmbed = ({ url }: { url: string }) => {
  const ref = useRef<HTMLQuoteElement>(null);

  useEffect(() => {
    loadInstagramScript();
  }, [url]);

  return (
    <blockquote
      ref={ref}
      className="instagram-media"
      data-instgrm-permalink={url}
      data-instgrm-version="14"
      style={{
        background: "#FFF",
        border: 0,
        borderRadius: 12,
        boxShadow: "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
        margin: "0 auto",
        maxWidth: 540,
        minWidth: 270,
        padding: 0,
        width: "100%",
      }}
    >
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-accent hover:underline"
      >
        View post on Instagram
        <span className="sr-only"> (opens in a new tab)</span>
      </a>
    </blockquote>
  );
};